import React, {
  forwardRef,
  useImperativeHandle,
  useMemo,
  useState
} from 'react'

import {
  Botao,
  FormUnform,
  InputUnform,
  ModalBaseProps,
  Spacer
} from 'src/componentes'
import { ModalBase } from 'src/componentes/modal-base'

import { Corpo, ContainerBotoes } from '../../styles'
import { createSchema } from './schema'
import { ModalEditarModuloCertificacaoRef } from './tipos'

const ModalEditar: React.ForwardRefRenderFunction<
  ModalEditarModuloCertificacaoRef,
  ModalBaseProps
> = ({ backdrop, acaoPrimaria }, ref) => {
  const [aberta, definirAberta] = useState(false)
  const [pronto, definirPronto] = useState(false)

  const [moduloEditavel, definirModuloEditavel] = useState<any>()

  const fechar = () => {
    definirPronto(false)
    definirAberta(false)
    definirModuloEditavel(undefined)
  }

  const abrir = (item: any) => {
    definirModuloEditavel(item)
    definirPronto(true)
    definirAberta(true)
  }

  useImperativeHandle<
    ModalEditarModuloCertificacaoRef,
    ModalEditarModuloCertificacaoRef
  >(ref, () => ({
    fechar,
    abrir
  }))

  const acaoSucesso = async (dados: any) => {
    acaoPrimaria(dados)
    fechar()
  }

  const dadosIniciais = useMemo(() => {
    return {
      nome: moduloEditavel?.nome
    }
  }, [moduloEditavel])
  return (
    <>
      <ModalBase aberta={aberta} backdrop={backdrop}>
        <Corpo>
          <h5>Editar Módulo</h5>
          <Spacer padding="10px 0px" />
          {pronto && (
            <FormUnform
              schema={createSchema}
              dadosIniciais={dadosIniciais}
              acaoSucesso={acaoSucesso}
            >
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  gap: '15px'
                }}
              >
                <div style={{ width: '75%' }}>
                  <InputUnform
                    name="nome"
                    label="Nome do Módulo"
                    obrigatorio
                    maxLength={200}
                  />
                </div>
              </div>
              <Spacer padding="10px 0px" />
              <ContainerBotoes>
                <Botao
                  type="button"
                  id="btn-cancelar"
                  texto="Cancelar"
                  tema="Secundario"
                  onClick={() => {
                    fechar()
                  }}
                />
                <Botao id="btn-salvar" texto="Salvar" type="submit" />
              </ContainerBotoes>
            </FormUnform>
          )}
        </Corpo>
      </ModalBase>
    </>
  )
}
export const ModalEditarModulo = forwardRef(ModalEditar)
